export class FloatingActionButton {
  iconClass: string;
  label?: string;
  onClick: () => void;
}
